/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { FolderCreationRequest } from '../../models/folder-creation-request';
import { FolderCreationResponse } from '../../models/folder-creation-response';

export interface MediaControllerMakeDir$Params {
      body: FolderCreationRequest
}

export function mediaControllerMakeDir(http: HttpClient, rootUrl: string, params: MediaControllerMakeDir$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: FolderCreationResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, mediaControllerMakeDir.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: FolderCreationResponse;
      }>;
    })
  );
}

mediaControllerMakeDir.PATH = '/file-manager/mkdir';
